import { RootState } from '../../../applicationStore';
import { TimesheetLocksState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getTimesheetLocksState = (state: RootState): TimesheetLocksState =>
  state.timesheetLocks;

export const getTimesheetsLoader = createSelector(
  getTimesheetLocksState,
  (state): boolean => state.loading,
);

export const getTimesheetLocksData = createSelector(
  getTimesheetLocksState,
  (state): TimesheetLocksState['data'] | null => state?.data || [],
);
